import React, { useCallback } from 'react';
import { serializeFormJSON } from '../../form-serialization';
export class FormUsageError extends Error {
    constructor(msg, form) {
        super(msg);
        this.form = form;
    }
}
let api;
let capturer;
export function init(initApi, initCapturer) {
    api = initApi;
    capturer = initCapturer;
}
export const JSONForm = ({ method, path, preSubmit, onSuccess, onFailure, formRef, id, onChange, children, }) => {
    const onSubmit = useCallback(async (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        if (!method) {
            throw new FormUsageError('Form method not set', form);
        }
        if (method.toLocaleLowerCase() !== method) {
            throw new FormUsageError(`Malformed form method '${method}'`, form);
        }
        if (!form.action) {
            throw new FormUsageError('Form action not set', form);
        }
        const inputs = Array.from(form.querySelectorAll('textarea, input, select, button'));
        for (const input of inputs) {
            if (input.type === 'submit') {
                input.classList.add('active');
            }
            input.disabled = true;
        }
        try {
            const headers = new Headers();
            const payload = serializeFormJSON(form);
            const requestOptions = {
                headers,
                method,
                payload: method !== 'delete' ? payload : undefined,
                url: path,
            };
            if (preSubmit) {
                preSubmit({
                    inputs: payload,
                    requestOptions,
                });
            }
            const res = await api.request(requestOptions);
            onSuccess(res);
        }
        catch (err) {
            if (onFailure && onFailure(err)) {
                return;
            }
            capturer(err);
        }
        finally {
            for (const input of inputs) {
                if (input.type === 'submit') {
                    input.classList.remove('active');
                }
                input.disabled = false;
            }
        }
    }, [method, path, preSubmit, onSuccess, onFailure]);
    return (
    // tslint:disable-next-line promise-function-async
    React.createElement("form", { id: id || '', ref: formRef, method: 'post', action: path, onChange: onChange, onSubmit: onSubmit },
        React.createElement(React.Fragment, null, children)));
};
//# sourceMappingURL=JSONForm.js.map